export const READ_MORE_LINE_HEIGHT = 20;
export const RICH_POST_COLLAPSED_LINES = 3;

export const normalizeCollapsedHeight = (height: number): number =>
	Math.max(
		READ_MORE_LINE_HEIGHT,
		Math.floor(height / READ_MORE_LINE_HEIGHT) * READ_MORE_LINE_HEIGHT,
	);

export const getReadMoreLabel = (expanded: boolean): string =>
	expanded ? "See less" : "See more";

// The collapsed-card height must not constrain a description after the member
// explicitly asks to see the full text.
export const getExpandedMaxHeight = (): string => "none";
